var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.docsRegistry)?_c('small',[_vm._v("Рейс не включен в опись")]):_c('router-link',{attrs:{"to":_vm.url}},[_vm._v(_vm._s(_vm.linkText))])
}
var staticRenderFns = []

export { render, staticRenderFns }